import React from 'react';
import itgLogo from '../../../../../Components/utils/ITG_BLANCO.png';

const LEVEL_LABELS = { centro: 'Centro', area: 'Área', region: 'Región' };

/**
 * Muestra la ubicación activa y abre el selector geográfico.
 */
export function LocationSelectorButton({ level, name, onOpen }) {
  return (
    <button
      className="scapp-full-location"
      onClick={onOpen}
      title="Seleccionar centro, área o región"
    >
      {LEVEL_LABELS[level]} - {name || 'Seleccionar ubicación'}
    </button>
  );
}

/**
 * Muestra el acceso con marca ITG que controla el drawer de navegación.
 */
export function ItgMenuButton({ onOpen, onClose }) {
  return (
    <button
      type="button"
      className="scapp-full-itg"
      onClick={onOpen}
      onMouseEnter={onOpen}
      onMouseLeave={onClose}
      aria-label="Menú"
    >
      <img src={itgLogo} alt="ITG" />
    </button>
  );
}
